import type { EventReminder } from 'models';
import { useCallback } from 'react';
import { Form, FormActions, message } from 'ui';
import type { ExtendedReminderInvitationsFormValues } from '../../../../../invitations-form-content';
import { useAddEventDistributionListMutation, useAddEventParticipantsMutation } from '../../../../../queries';
import { useGetInvitationsRequestData } from './hooks';
import { ReminderInvitationsFormContentWrapper } from './reminder-invitations-form-content-wrapper';

type InvitationsFormValues = ExtendedReminderInvitationsFormValues;

type P = {
  event: EventReminder;
  onClose: () => void;
};

const SendInvitationsModalContent = ({ event, onClose }: P) => {
  const { isPending: isAddingDistributionList, mutateAsync: addDistributionList } =
    useAddEventDistributionListMutation();
  const { isPending: isAddingParticipants, mutateAsync: addParticipants } = useAddEventParticipantsMutation();
  const getInvitationsRequestData = useGetInvitationsRequestData();

  const submit = useCallback(
    async (formValues: InvitationsFormValues) => {
      const { distributionList, participants } = getInvitationsRequestData(formValues);

      // TODO: Consider using Promise.allSettled and handling individual errors.
      await Promise.all([
        distributionList.length > 0 ? addDistributionList({ distributionList, eventId: event.id }) : Promise.resolve(),
        participants.length > 0 ? addParticipants({ eventId: event.id, participants }) : Promise.resolve(),
      ]);

      message.success('Invitations sent successfully');
      onClose();
    },
    [addDistributionList, addParticipants, event.id, getInvitationsRequestData, onClose],
  );

  return (
    <Form<InvitationsFormValues> onFinish={submit}>
      <ReminderInvitationsFormContentWrapper<InvitationsFormValues> event={event} isRequired />
      <FormActions
        right={{
          children: 'Back',
          onClick: onClose,
        }}
        submit={{ children: 'Send', loading: isAddingDistributionList || isAddingParticipants }}
      />
    </Form>
  );
};

export default SendInvitationsModalContent;
